import { CompanyStatus } from '../../common/constants';

export const reportRedirectStatuses = [
  CompanyStatus.BLOCKED,
  CompanyStatus.UNDER_INVESTIGATION,
] as const;

export const companyStatusQueryParam = 'companyStatus';
